/* eslint-disable */ 
import { ajax, jsonp } from '@/utils/http/ajax'
import { getEnStr } from '@/utils/utils'
import { base64encode, utf16to8 } from '@/utils/enCodeAndDecode'

// FIXME:这里设定两个初始值 这俩初始值后面看下能不能优化
var pgeRZRandNum = "20e0myhdq4mcqvy6rp3fi7g1s0nff606";
var pgeRZDataB = "wlJWjHnUxFWQwERC5Tq1TZX5QToQSvezNcOdmXFfZcw=";

/**
 * SignMessenger.js
 * @param the tag id
 * @author kevin 20160923
 * @return control obj
 */
function SignMessenger(id) {
  // the js version
  this.sdkVersion = "1.0.0.1";
  var url = "https://windows10.microdone.cn";
  var port = 9000,
    urls = "";
  this.hasMacUKey = false;
  var sid = "sign" + new Date().getTime() + 1;
  var ua = navigator.userAgent.toLowerCase();
  // check chrome
  var chr = "",
    regStr_chrome = /chrome\/[\d.]+/gi;
  var regStr_firefox = /firefox\/[\d.]+/gi;
  if (navigator.platform == "Win64" && navigator.userAgent.indexOf("Firefox") > -1) {
    chr = "chromeh";
  }

  if (ua.indexOf("chrome") > 0) {
    var chromeVersion = ua.match(regStr_chrome).toString();
    chromeVersion = parseInt(chromeVersion.replace(/[^0-9.]/gi, ""));
    if (chromeVersion >= 42) {
      chr = "chromeh";
    } else {
      chr = "chromel";
    }
  }

  if (ua.indexOf("firefox") > 0) {
    var firefoxVersion = navigator.userAgent.match(regStr_firefox).toString();
    firefoxVersion = parseInt(firefoxVersion.replace(/[^0-9.]/gi, ""));
    if (firefoxVersion >= 50) {
      chr = "chromeh"
    } else {
      chr = "chromel";
    }
  }


  // check OS & browser
  this.env = {
    isWindows: (ua.indexOf("windows") != -1 || ua.indexOf("win32") != -1),
    isMac: (ua.indexOf("macintosh") != -1 || ua.indexOf("mac os x") != -1),
    isLinux: (ua.indexOf("linux") != -1),
    ie: (ua.indexOf('msie') != -1 || ua.indexOf("trident") != -1),
    firefox: ua.indexOf('firefox') != -1,
    chrome: ua.indexOf('chrome') != -1,
    opera: ua.indexOf('opera') != -1,
    safari: ua.indexOf('version') != -1,
    edge: ua.indexOf('edge') != -1 || chr.indexOf('chromeh') != -1
  };
  // create control tag
  this.createTag = function () {
    if (this.env.edge) {
      return "";
    } else if (this.env.isWindows && this.env.ie) {
      return "<object id='" +
        id +
        "' classid='CLSID:EC176F0A-69BE-4059-8546-B01EF8C0FB9C' width='0' height='0'></object>";
    } else if (this.env.isWindows || this.env.isMac) {
      return "<embed id='" +
        id +
        "' type='application/x-sign-messenger' width='0' height='0'>";
    } else {
      return "<object type='application/x-sign-messenger' id=''></object>";
    }
  };
  this.high = null, this.admin = null;
  // get control object
  this.getObj = function (admin) {
    console.log('admin', admin)
    var obj = document.getElementById(id);
    console.log('obj', obj)
    if ((admin != undefined) && this.env.ie) {
      if (admin) {
        if (this.admin == null) {
          this.admin = obj.getAdmin(admin);
        }
        return this.admin;
      } else {
        if (this.high == null) {
          this.high = obj.getAdmin(admin);
        }
        return this.high;
      }
      return obj.getAdmin(admin);
    }
    return obj;
  };
  // DN convert
  this.dnConvert = function (dn) {
    var dn_new = dn.replace(/\s=/g, '=');
    dn_new = dn_new.replace(/=\s/g, '=');
    dn_new = dn_new.replace(/=/g, ':"');
    dn_new = dn_new.replace(/cn:/g, 'CN:');
    dn_new = "{" + dn_new.replace(/,/g, '",') + '"}';
    if (dn_new.toUpperCase().indexOf("SN:") != -1) {
      dn_new = dn_new.toUpperCase();
      dn_new = dn_new.replace(/SN/g, 'SN');
      //dn_new = dn_new.replace(/\s/g, '');
      dn_new = dn_new.replace(/"(0+)/g, '"');
    }
    return dn_new;
  };
  this.trimRight = function (s) {
    if (s == null) return "";
    var whitespace = new String(" \t\n\r");
    var str = new String(s);
    if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
      var i = str.length - 1;
      while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
        i--;
      }
      str = str.substring(0, i + 1);
    }
    return str;
  }
  //发同步ajax请求
  this.pwdGetData = function (datas) {
    var d = 0;
    var str = JSON.stringify(datas).replace(/\+/g, "%2B");
    ajax.request({
      timeout: 1000,
      url: urls,
      type: 'POST',
      async: false,
      data: {
        "jsoncallback": "cb",
        "str": str
      },
      success: function (x) {
        x = x.responseText.substr("cb(".length);
        x = x.substring(0, x.length - 1);
        x = JSON.parse(x);
        d = x;
      },
      error: function (x) {
        d = -1;
      }
    });
    return d;
  }
  // get control version
  this.getVersion = function (callf) {
    var returnStr, version, obj = this;
    console.warn({
      returnStr,
      version,
      obj
    })
    try {
      if (this.env.edge) {
        console.warn('getVersion', 1)
        var INCJSON = {
          "interfacetype": 1,
          "data": {}
        };
        var datac = getEnStr(pgeRZRandNum, INCJSON);
        var RZCIJSON = {
          "rankey": pgeRZRandNum,
          "datab": pgeRZDataB,
          "datac": datac
        };
        urls = url + ":" + port;
        jsonp({
          time: 7000,
          url: urls,
          data: {
            "str": JSON.stringify(RZCIJSON),
            "jsoncallback": "cb"
          },
          callback: "jsoncallback",
          success: function (x) {
            version = x.data;
            var m = version.split(".");
            version = parseInt(m[0] * 1000) + parseInt(m[1] * 100) + parseInt(m[2] * 10) + parseInt(m[3]);
            if (!!callf) callf(version);
          },
          fail: function (jqXHR, textStatus, errorThrown) {
            //console.log("检测端口:"+port);
            if (port < 9004) {
              port++;
              obj.getVersion(callf);
            } else {
              if (!!callf) callf(false);
            }
          }
        });
        return;
      } else {
        console.warn('getVersion', 2)
        if (this.env.ie) {
          returnStr = this.getObj(false).version;
          console.log('returnStr', returnStr)
          console.log(returnStr.indexOf(":"))
        } else {
          returnStr = navigator.plugins['SignMessenger'].description;
        }
      }
      if (returnStr.indexOf(":") > 0) {
        var arr = returnStr.split(":");
        version = arr[1];
        console.log('version', version)
      }
      if (version == undefined || version == "") {
        return 0;
      } else {
        var flag = false,
          m = "";
        if (version.indexOf(",") > -1) flag = true;
        if (flag) m = version.split(",")
        else m = version.split(".");
        var v = parseInt(m[0] * 1000) + parseInt(m[1] * 100) + parseInt(m[2] * 10) + parseInt(m[3]);
        return v;
      }
    } catch (err) {
      console.error('error16', err)
      return 0;
    }
  };
  var keychain, cert, collection;
  //get cert obj
  this.getSCertificate = function (dn) {
    cert = null;
    if (dn == "") return null;
    try {
      if (this.env.isMac && this.hasMacUKey) {
        this.getMacUKeyCertificate(dn);
      } else {
        //				keychain = this.getObj(false).keychain("infosec.sm2");
        keychain = this.getObj(false).keychain();
        var dn_new = this.dnConvert(dn);
        dn_new = eval("(" + dn_new + ")");
        collection = keychain.query(dn_new);
        var data = new Array();
        var allCerts = collection;
        for (var i = 0; i < allCerts.length; i++) {
          data.push(allCerts.item(i).toString());
        }
        var postData = "";
        //console.log(data.length);
        if (data.length == 0) {
          postData = "";
        } else {
          postData = data.join(",");
        }
        //console.log(postData);
        collection.length > 1 ? cert = collection.userChoose() : cert = collection.item(0);
      }
    } catch (err) {
      console.error('error17', err)
    }
  };
  //get cert info
  this.getSCertInfo = function (dn, attrNum) {
    if (dn == "") return null;
    if (this.env.edge) {
      if (this.env.isMac && this.hasMacUKey) {
        var cl = this.getTokenAndSelKey(dn);
      } else {
        var cl = this.getCL(dn);
      }
      if (cl == null) {
        return null;
      }
      var certnumber = cl.certnumber,
        isUI = 1;
      if (certnumber > 0) {
        certlist = cl.certlist;
        certid = certlist[0].certid;
        if (certnumber == 1) {
          isUI = 0;
        }
        var cc = this.selectCert(pid, certid, 6, isUI);
        if (cc.code == 0) {
          var ci = this.getCertInfo(pid, 0);
          var certObj = ci.certinfo;
          switch (attrNum) {
            case 0:
              return certObj.sn;
            case 1:
              return certObj.cn;
            case 2:
              return certObj.c;
            case 3:
              return certObj.o;
            case 4:
              return certObj.ou;
            case 5:
              return certObj.e;
            case 6:
              return certObj.pub;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      this.getSCertificate(dn);
      if (cert == null) return null;
      var certObj = cert.subject(new Object);
      switch (attrNum) {
        case 0:
          return cert.SerialNumber;
        case 1:
          return certObj.CN;
        case 2:
          return certObj.C;
        case 3:
          return certObj.O;
        case 4:
          return certObj.OU;
        case 5:
          return certObj.emailAddress;
        case 6:
          return cert.toString();
      }
    }
  };
  var content, pid, code, certid, certlist, result, version;
  //data sign
  this.sSign = function (dn, content, flag) {
    if (dn == "" || content == "") return "";
    if (this.env.edge) {
      if (this.env.isMac && this.hasMacUKey) {
        var cl = this.getTokenAndSelKey(dn);
      } else {
        var cl = this.getCL(dn);
      }
      if (cl == null) {
        return null;
      }
      var certnumber = cl.certnumber,
        isUI = 0;
      if (certnumber > 0) {
        certlist = cl.certlist;
        certid = certlist[0].certid;
        if (certnumber > 1) {
          isUI = 1;
        } else if (certnumber == 1) {
          isUI = 0;
        }
      } else {
        return false;
      }
      this.selectCert(pid, certid, 6, isUI);
      content = base64encode(utf16to8(this.trimRight(content)));
      var st = this.signature(pid, content, flag, 1);
      if (st.code != 0) {
        result = false;
      } else {
        result = st.signed;
      }
      return result;
    } else {
      this.getSCertificate(dn);
      if (this.env.isMac) {
        console.warn('cert1', cert)
        return cert.sign(content, 0);
      } else {
        console.warn('cert2', cert)
        return cert.sign(content, parseInt(flag));
      }
    }
  };
  //create the csr(pkcs#10 standard)
  this.getCsr = function (mask, type) {
    try {
      if (this.env.edge) {
        pid = this.getProvider("", 0, 0);
        return this.getCertCSR(pid, 1, mask)
      } else {
        keychain = this.getObj(false).keychain();
        return keychain.createCSR(mask, type);
      }
    } catch (err) {
      console.error('error18', err)
      return false;
    }
  };
  // import cert to certmgr
  this.importCert = function (certStr, type, location) {
    if (certStr == undefined || type == undefined || location == undefined || certStr == "") return false;
    try {
      if (this.env.edge) {
        pid = this.getProvider("", 0, 0);
        code = this.importCert2(pid, 1, certStr, 2);
        return code == 0 ? true : false;
      } else {
        if (this.env.isMac) {
          if (location == 0) { //root cert
            keychain = this.getObj(false).keychain("root");
          } else if (location == 1) {
            keychain = this.getObj(false).keychain();
          }
        } else {
          if (location == 0) { //dotrust root cert
            keychain = this.getObj(false).keychain("root");
          } else if (location == 1) {
            keychain = this.getObj(false).keychain();
          } else if (location == 2) { //middle cert
            keychain = this.getObj(false).keychain("CA");
          }
        }
        return keychain.importCertificate(certStr, type);
      }
    } catch (err) {
      console.error('error19', err)
      return false;
    }
  };
  // delete the cert
  this.sDelCert = function (dn) {
    if (this.env.edge) {
      var dn_new = this.dnConvert(dn);
      dn_new = eval("(" + dn_new + ")");
      pid = this.getProvider("", 0, 0);
      var cl = this.getCertList(pid, 5, dn_new);
      var certnumber = cl.certnumber;
      certlist = cl.certlist;
      certid = certlist[0].certid;
      if (certnumber == 1) {
        var cc = this.selectCert(pid, certid, 6, 0);
        if (cc.code != 0) {
          return null;
        } else {
          code = this.delCert2(pid, certid, 4)
          return code == 0 ? true : false;
        }
      } else if (certnumber > 1) {
        var cc = this.selectCert(pid, certid, 6, 1);
        if (cc.code != 0) {
          return null;
        } else {
          code = this.delCert2(pid, certid, 4)
          return code == 0 ? true : false;
        }
      } else {
        return null;
      }
    } else {
      this.getSCertificate(dn);
      if (cert == null) return null;
      return cert.remove();
    }
  };
  // get the certobj by ukey(only in Mac OS X)
  this.getMacUKeyCertificate = function (dn) {
    cert = null;
    var token_ft1, token_ft, token_zj;
    token_ft1 = this.getObj(false).token("libePass_BOCD"); // ft
    token_ft = this.getObj(false).token("libBOCD"); // ft
    token_zj = this.getObj(false).token("ZJMacUkey"); // zj
    if (token_ft1 == null && token_ft == null && token_zj == null) {
      return false;
    }
    if (token_ft1 != null && token_ft1.keyCount()) {
      var keyCount = parseInt(token_ft1.keyCount() + "");
      for (var i = 0; i < keyCount; i++) {
        token_ft1.selectKey(i);
        var certCount = parseInt(token_ft1.certCount() + "");
        if (certCount > 0) {
          cert = token_ft1.getActiveCertificate();
        }
      }
    }
    if (cert == null) {
      if (token_ft != null && token_ft.keyCount()) {
        var keyCount = parseInt(token_ft.keyCount() + "");
        for (var i = 0; i < keyCount; i++) {
          token_ft.selectKey(i);
          var certCount = parseInt(token_ft.certCount() + "");
          if (certCount > 0) {
            cert = token_ft.getActiveCertificate();
          }
        }
      }
    }
    if (cert == null) {
      if (token_zj != null && token_zj.keyCount()) {
        var keyCount = parseInt(token_zj.keyCount() + "");
        for (var i = 0; i < keyCount; i++) {
          token_zj.selectKey(i);
          var certCount = parseInt(token_zj.certificateCount() + "");
          if (certCount > 0) {
            cert = token_zj.getActiveCertificate();
          }
        }

      }
    }
  };
  // the edge && chrome45+ api
  // get cl
  this.getCL = function (dn) {
    pid = this.getProvider("", 0, 0);
    var dn_new = this.dnConvert(dn);
    dn_new = eval("(" + dn_new + ")");
    return this.getCertList(pid, 5, dn_new);
  };
  // get csp provider
  this.getProvider = function (name, type, pcode) {
    var SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.name = name, SETJSON.data.type = type, SETJSON.data.pcode = pcode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    var x = this.pwdGetData(RZCIJSON);
    return x.pid;
  };
  //get cert list
  this.getCertList = function (pid, pcode, query) {
    var res, SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.pcode = pcode, SETJSON.data.query = query;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    res = this.pwdGetData(RZCIJSON);
    return res;
  };
  //select cert
  this.selectCert = function (pid, certid, pcode, type) {
    var res, SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.certid = certid;
    SETJSON.data.pcode = pcode, SETJSON.data.type = type;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    res = this.pwdGetData(RZCIJSON);
    return res;
  };
  //sign data
  this.signature = function (pid, sign, flags, ccode) {
    var res, SETJSON = {
      id: sid,
      interfacetype: 0,
      data: {
        pid,
        sign,
        flags,
        ccode
      }
    }
    // SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.sign = sign;
    // SETJSON.data.flags = flags, SETJSON.data.ccode = ccode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    res = this.pwdGetData(RZCIJSON);
    return res;
  };
  //get certinfo
  this.getCertInfo = function (pid, ccode) {
    var res, SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.ccode = ccode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    res = this.pwdGetData(RZCIJSON);
    return res;
  };
  //create csr
  this.getCertCSR = function (pid, pcode, csrinfo) {
    var csr = null,
      SETJSON = {
        "interfacetype": 0,
        "data": {}
      };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.pcode = pcode, SETJSON.data.csrinfo = csrinfo;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    csr = this.pwdGetData(RZCIJSON).csr;
    return csr;
  };
  //import cert
  this.importCert2 = function (pid, format, data, pcode) {
    var code = 3,
      SETJSON = {
        "interfacetype": 0,
        "data": {}
      };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.format = format;
    SETJSON.data.data = data, SETJSON.data.pcode = pcode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    code = this.pwdGetData(RZCIJSON).code;
    return code;
  };
  //delete cert
  this.delCert2 = function (pid, certid, pcode) {
    var code = 3,
      SETJSON = {
        "interfacetype": 0,
        "data": {}
      };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.certid = certid, SETJSON.data.pcode = pcode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    code = this.pwdGetData(RZCIJSON).code;
    return code;
  };
  //the api in mac os x
  // get token and select key
  this.getTokenAndSelKey = function (dn) {
    var pid_ft = this.getProvider("libBOCD", 1, 0);
    var pid_ft1 = this.getProvider("libePass_BOCD", 1, 0);
    var pid_zj = this.getProvider("ZJMacUkey", 1, 0);
    var cl = null;
    if (cl == null) {
      if (pid_zj != -1) {
        var keyCount = this.getKeyCount(pid_zj, 7);
        if (keyCount) {
          var code = this.selectKey(pid_zj, 0, 8);
          var dn_new = this.dnConvert(dn);
          dn_new = eval("(" + dn_new + ")");
          cl = this.getCertList(pid_zj, 5, dn_new);
          pid = pid_zj;
        }
      }
    }
    if (cl == null) {
      if (pid_ft != -1) {
        var keyCount = this.getKeyCount(pid_ft, 7);
        if (keyCount) {
          var code = this.selectKey(pid_ft, 0, 8);
          var dn_new = this.dnConvert(dn);
          dn_new = eval("(" + dn_new + ")");
          cl = this.getCertList(pid_ft, 5, dn_new);
          pid = pid_ft;
        }
      }
    }
    if (cl == null) {
      if (pid_ft1 != -1) {
        var keyCount = this.getKeyCount(pid_ft1, 7);
        if (keyCount) {
          var code = this.selectKey(pid_ft1, 0, 8);
          var dn_new = this.dnConvert(dn);
          dn_new = eval("(" + dn_new + ")");
          cl = this.getCertList(pid_ft1, 5, dn_new);
          pid = pid_ft1;
        }
      }
    }
    return cl;
  };
  //get key count
  this.getKeyCount = function (pid, pcode) {
    var SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.pcode = pcode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    var x = this.pwdGetData(RZCIJSON);
    return x.keycount;
  };
  //select key
  this.selectKey = function (pid, keyindex, pcode) {
    var SETJSON = {
      "interfacetype": 0,
      "data": {}
    };
    SETJSON.id = sid, SETJSON.data.pid = pid, SETJSON.data.keyindex = keyindex;
    SETJSON.data.pcode = pcode;
    var datac = getEnStr(pgeRZRandNum, SETJSON);
    var RZCIJSON = {
      "rankey": pgeRZRandNum,
      "datab": pgeRZDataB,
      "datac": datac
    };
    this.pwdGetData(RZCIJSON);
  };
}
//init signmessenger
export const signObj = new SignMessenger('smObj');

//refresh the plugin array(in W3C Browser)
if (navigator.userAgent.indexOf("MSIE") < 0) {
  navigator.plugins.refresh();
}

